import React, { useState, useEffect } from "react";
import { Card } from "antd";
import DefaultProductImage from "../../assets/images/no-image.svg";
import templateConfig from "./template.json"; // Import the template.json file
import Scrollbars from "react-custom-scrollbars";

export default function VideoTemplate() {
  const layoutConfig = templateConfig.video || {}; // Access video layout with fallback
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const customerDisplayJSON = posConfig?.customerDisplayTheme ? JSON.parse(posConfig?.customerDisplayTheme) : {};
  const videos = customerDisplayJSON?.video?.videos || [
    {
      id: 1,
      title: "Fresh Coffee Experience",
      color: "linear-gradient(to bottom right, #F59E0B, #EA580C)",
      url: "",
      icon: "☕",
      description: "Experience the difference",
    },
    {
      id: 2,
      title: "Artisan Pastries",
      color: "linear-gradient(to bottom right, #EC4899, #E11D48)",
      icon: "🥐",
      url: "",
      description: "Savor the artistry",
    },
    {
      id: 3,
      title: "Premium Quality",
      color: "linear-gradient(to bottom right, #22C55E, #059669)",
      icon: "⭐",
      url: "",
      description: "Quality you can trust",
    },
  ];
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const precision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;

  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cartObj");
    return savedCart ? JSON.parse(savedCart) : { items: [], total: 0, paid: 0, salesRepName: "" };
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const savedCart = localStorage.getItem("cartObj");
      if (savedCart) {
        setCart(JSON.parse(savedCart));
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const [currentVideo, setCurrentVideo] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideo((prev) => (prev + 1) % videos.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [videos.length]);

  return (
    <div
      style={{
        height: "100vh",
        background: customerDisplayJSON.backgroundColor || "#000000",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          //flexDirection: customerDisplayJSON.viewMode === "portrait" ? "column" : "row",
        }}
      >
        {/* Video Area - 3/4 of screen */}
        <div style={{ flex: 3, position: "relative", height: "100vh" }}>
          {videos.map((video, index) => (
            <div
              key={video.id}
              style={{
                position: "absolute",
                inset: 0,
                transition: "opacity 1s",
                opacity: index === currentVideo ? 1 : 0,
              }}
            >
              <div
                style={{
                  height: "100%",
                  background: video.color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                {/* Video Background Simulation */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    opacity: 0.3,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      background: customerDisplayJSON.videoSectionBGColor || "linear-gradient(to right, rgba(0,0,0,0.2), transparent, rgba(0,0,0,0.2))",
                    }}
                  ></div>
                </div>

                {/* Content */}
                <div style={{ textAlign: "center", color: customerDisplayJSON.videoTextColor || "#FFFFFF", zIndex: 10, fontSize: "1vw" }}>
                  <div
                    style={{
                      fontSize: customerDisplayJSON.videoIconFontSize || "4em",
                      marginBottom: 32,
                      animation: "pulse 2s infinite",
                    }}
                  >
                    {video.icon}
                  </div>
                  <h1
                    style={{
                      fontSize: customerDisplayJSON.videoTitleFontSize || "5em",
                      fontWeight: "bold",
                      marginBottom: 16,
                      textShadow: "0 4px 6px rgba(0,0,0,0.3)",
                    }}
                  >
                    {video.title}
                  </h1>
                  <div
                    style={{
                      fontSize: customerDisplayJSON.videoDescriptionFontSize || "4em",
                      opacity: 0.8,
                    }}
                  >
                    {video.description || "Experience the difference"}
                  </div>
                </div>

                {/* Video Controls Simulation */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 32,
                    left: 32,
                    right: 32,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 12,
                    }}
                  >
                    {videos.map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentVideo(i)}
                        style={{
                          width: 16,
                          height: 16,
                          borderRadius: "50%",
                          background:
                            i === currentVideo
                              ? customerDisplayJSON.videoControlsDotColorActive || "#FFFFFF"
                              : customerDisplayJSON.videoControlsDotColorInactive || "rgba(255,255,255,0.5)",
                          transform: i === currentVideo ? "scale(1.25)" : "scale(1)",
                          transition: "all 0.3s",
                          border: "none",
                          cursor: "pointer",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Order Panel - 1/4 of screen */}
        <div
          style={{
            flex: 1,
            background: customerDisplayJSON.orderPanelBGColor || "#111827",
            padding: 20,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {/* Fixed Header */}
          <div style={{ textAlign: "center", marginBottom: 24, flexShrink: 0 }}>
            {customerDisplayJSON.logoURL && <img src={customerDisplayJSON.logoURL} alt="Logo" style={{ height: 40, marginBottom: 8 }} />}
            <h2
              style={{
                fontSize: 24,
                fontWeight: "bold",
                color: customerDisplayJSON.orderPanelHeaderColor || "#FFFFFF",
                marginBottom: 8,
              }}
            >
              Your Order
            </h2>
            <div
              style={{
                width: 64,
                height: 1,
                background: customerDisplayJSON.orderPanelDividerColor || "rgba(255,255,255,0.3)",
                margin: "0 auto",
              }}
            ></div>
          </div>

          {/* Content Area (Items List + Total) */}
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            {cart.items.length === 0 ? (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 80,
                    height: 80,
                    background: customerDisplayJSON.cartEmptyIconBGColor || "rgba(255,255,255,0.1)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: 30 }}>🛒</span>
                </div>
                <p style={{ color: customerDisplayJSON.cartEmptyTextColor || "rgba(255,255,255,0.7)", textAlign: "center" }}>No items yet</p>
              </div>
            ) : (
              <>
                {/* Scrollable Items List */}
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 5,
                    // overflowX: "hidden",
                    paddingRight: 8,
                    minHeight: 0,
                  }}
                >
                  <Scrollbars autoHide style={{ height: "60vh" }} renderView={(props) => <div {...props} style={{ ...props.style, overflowX: "hidden" }} />}>
                    {cart.items.map((item) => (
                      <Card
                        key={item.id}
                        style={{
                          background: customerDisplayJSON.cartItemCardBGColor || "rgba(255,255,255,0.1)",
                          border: customerDisplayJSON.cartItemCardBorder || "1px solid rgba(255,255,255,0.2)",
                          flexShrink: 0,
                        }}
                        bodyStyle={{ padding: 16 }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={item.imageurl || DefaultProductImage}
                            alt={item.name}
                            style={{
                              width: 30,
                              height: 30,
                              objectFit: "cover",
                              borderRadius: 4,
                              marginRight: "1em",
                            }}
                          />
                          <div style={{ flex: 1 }}>
                            <h4
                              style={{
                                color: customerDisplayJSON.cartItemTextColor || "#FFFFFF",
                                fontWeight: 600,
                                fontSize: 12,
                              }}
                            >
                              {item.name}
                            </h4>
                            <p
                              style={{
                                color: customerDisplayJSON.cartEmptyTextColor || "rgba(255,255,255,0.7)",
                                fontSize: 12,
                              }}
                            >
                              Qty: {parseFloat(item.weight).toFixed(item.isQtyDesimal ?? 2)}
                            </p>
                          </div>
                          <div
                            style={{
                              color: customerDisplayJSON.cartItemPriceColor || "#FFFFFF",
                              fontWeight: "bold",
                              fontSize: 12,
                            }}
                          >
                            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                            {parseFloat(item.nettotal).toFixed(precision)}
                            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                          </div>
                        </div>
                      </Card>
                    ))}
                  </Scrollbars>
                </div>

                {/* Fixed Total Section */}
                <div
                  style={{
                    borderTop: customerDisplayJSON.cartTotalSectionBorderColor || "1px solid rgba(255,255,255,0.2)",
                    flexShrink: 0,
                    paddingTop: 16,
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        color: customerDisplayJSON.cartTotalTextColor || "rgba(255,255,255,0.7)",
                        fontSize: 14,
                        marginBottom: 4,
                      }}
                    >
                      Total
                    </div>
                    <div
                      style={{
                        fontSize: 30,
                        fontWeight: "bold",
                        color: customerDisplayJSON.cartTotalAmountColor || "#FFFFFF",
                      }}
                    >
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      {parseFloat(cart.total).toFixed(precision)}
                      {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Fixed Live Updates Section */}
          <div style={{ marginTop: 24, textAlign: "center", flexShrink: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <div
                style={{
                  width: 8,
                  height: 8,
                  background: customerDisplayJSON.liveUpdatesDotColor || "#4ADE80",
                  borderRadius: "50%",
                  animation: "pulse 2s infinite",
                }}
              ></div>
              <span
                style={{
                  color: customerDisplayJSON.liveUpdatesTextColor || "rgba(255,255,255,0.7)",
                  fontSize: 14,
                }}
              >
                Live Updates
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
